import  ActionType from './ActionType';
import { DatalinkAPIModels } from '../generated/src/dlAPI';

interface IDataState {
  extractionbuilderdata: DatalinkAPIModels.ExtractionBuilderData;
  fetchingExtractionBuilderData: boolean;
}
export const initialDataState: IDataState = {} as IDataState;
export type dataState = typeof initialDataState;

export type DataAction =
  | { type: ActionType.SET_DATA_EXTRACTION_BUILDER; data: object }
  | { type: ActionType.DATA_EXTRACTION_BUILDER_START; data: boolean }
  | { type: ActionType.UPDATE_DATA_EXTRACTION_BUILDER; data: object; providerid: '' };

export const dataReducer = (state: dataState, action: DataAction) => {
  switch (action.type) {
    case ActionType.DATA_EXTRACTION_BUILDER_START:
      return { ...state, fetchingExtractionBuilderData: true };
    case ActionType.SET_DATA_EXTRACTION_BUILDER:
      return { ...state, extractionbuilderdata: action.data, fetchingExtractionBuilderData: false };
    case ActionType.UPDATE_DATA_EXTRACTION_BUILDER:
      { 
        const providers = state.extractionbuilderdata.providers.map((item: any) => {
          if (item.id === action.providerid){
            return {...item, yAxisCoords: action.data['yAxisCoords'], xAxisCoords: action.data['xAxisCoords']}
          }
          else{
            return item;
          }
        });
       

        return {...state, extractionbuilderdata: {...state.extractionbuilderdata, providers}}
    }
    default:
      return state;
  }
};
